/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DiplomatObject} from './DiplomatObject';
import {DBSettings} from './DBSettings';
import {DiplomatObjectType} from './DiplomatObjectType';

export const auditTrailSettingsSchema = DiplomatObject.shape({
   objectType: DiplomatObject.fields.objectType.default(
      DiplomatObjectType.enum.AUDIT_TRAIL_SETTINGS
   ),
   auditRequired: yup.boolean(),
   failureCritical: yup.boolean(),
   dbSettings: DBSettings,
   archive: yup.boolean(),
   archiveByAge: yup.boolean(),
   archiveByRecords: yup.boolean(),
   maxAge: yup.number().integer(),
   maxNumberRecords: yup.number().integer(),
   // Changed from integer:
   lastArchiveAttempt: yup.string(),
   lookupCountryCode: yup.boolean(),
});
export type AuditTrailSettings = yup.InferType<typeof auditTrailSettingsSchema>;
